import { requestBuilder } from '../../http/RequestBuilder';
import { type UpdateAdminUserEntraTokenDto } from '../types/AdminUserTypes';

export const useUpdateAdminUserEntraToken = requestBuilder.mutation<
    unknown,
    UpdateAdminUserEntraTokenDto
>({
    endpoint: '/api/admin/admin-user/entra-token',
    method: 'PATCH',
});
